import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 7.09141C3 6.06082 3.66644 5.14852 4.64823 4.83514L8.05273 3.74843C8.55659 3.5876 9.09533 3.57056 9.60834 3.69923L14.3917 4.89887C14.9047 5.02753 15.4434 5.01049 15.9473 4.84966L19.1468 3.82837C20.0636 3.53575 21 4.21981 21 5.18213V16.9086C21 17.9392 20.3336 18.8515 19.3518 19.1649L15.9473 20.2516C15.4434 20.4124 14.9047 20.4294 14.3917 20.3008L9.60834 19.1011C9.09532 18.9725 8.55659 18.9895 8.05273 19.1503L4.85317 20.1716C3.93641 20.4643 3 19.7802 3 18.8179V7.09141Z"
      stroke="#262626"
      stroke-width="1.89474"
    />
    <path d="M13.6128 9.5V14.5" stroke="#262626" stroke-width="1.75" stroke-linecap="round" />
    <path
      d="M13.6128 9.25H14.8906C16.1179 9.25 17.1128 10.2449 17.1128 11.4722V12.5278C17.1128 13.7551 16.1179 14.75 14.8906 14.75H13.6128"
      stroke="#262626"
      stroke-width="1.75"
      stroke-linecap="round"
    />
    <path d="M8.79316 8.87134L6.69075 14.7499" stroke="#262626" stroke-width="1.75" stroke-linecap="round" />
    <path d="M9.21534 8.88936L11.2744 14.7506" stroke="#262626" stroke-width="1.75" stroke-linecap="round" />
    <path d="M10.4175 13.375H7.62548" stroke="#262626" stroke-width="1.75" stroke-linecap="round" />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.76475 2.84592C8.43656 2.63148 9.15488 2.60876 9.8389 2.78031L14.6222 3.97995C14.9642 4.06573 15.3234 4.05437 15.6593 3.94715L18.8589 2.92586C20.3868 2.43815 21.9475 3.57825 21.9475 5.18213V16.9086C21.9475 18.3514 21.0145 19.6286 19.64 20.0674L16.2355 21.1541C15.5636 21.3685 14.8453 21.3912 14.1613 21.2197L9.37798 20.02C9.03597 19.9343 8.67681 19.9456 8.34091 20.0528L5.14135 21.0741C3.61342 21.5618 2.05273 20.4217 2.05273 18.8179V7.0914C2.05273 5.64857 2.98575 4.37136 4.36025 3.93263L7.76475 2.84592Z"
      fill="url(#paint0_linear_18903_5612)"
    />
    <path d="M13.6128 9.5V14.5" stroke="white" stroke-width="1.75" stroke-linecap="round" />
    <path
      d="M13.6128 9.25H14.8906C16.1179 9.25 17.1128 10.2449 17.1128 11.4722V12.5278C17.1128 13.7551 16.1179 14.75 14.8906 14.75H13.6128"
      stroke="white"
      stroke-width="1.75"
      stroke-linecap="round"
    />
    <path d="M8.79316 8.87134L6.69075 14.7499" stroke="white" stroke-width="1.75" stroke-linecap="round" />
    <path d="M9.21534 8.88936L11.2744 14.7506" stroke="white" stroke-width="1.75" stroke-linecap="round" />
    <path d="M10.4175 13.375H7.62548" stroke="white" stroke-width="1.75" stroke-linecap="round" />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5612"
        x1="5.19401"
        y1="4.13783"
        x2="20.3343"
        y2="20.8211"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconAdvertise() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
